/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import styled from 'styled-components/native';

// import { getScaledValue } from 'renative';

import Icons from './../../../assets/icons';
import { getScaledValue } from '../../../ui/styled';

export const Container = styled.View.attrs({})`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  background-color: rgba(22, 22, 22, 0.5);

  align-items: center;
  justify-content: center;

  overflow: hidden;

  max-height: 100vh;
  max-width: 100vw;

  ${(p: { opened?: boolean }) =>
    !p.opened
      ? `
            overflow: hidden;        
            max-height: 0;
            max-width: 0;
        `
      : ``}
`;
